module.exports = __webpack_public_path__ + "static/media/logo-silestone.9adee56f.svg";